export enum LoyaltyProgramCapabilities {
  Benefit = 'benefit',
  PointsTransfer = 'points_transfer',
  CashBackToCard = 'cashback_to_card',
  CashBackToAccount = 'cashback_to_account',
  CashBackToPlatform = 'cashback_to_platform',
}

export interface LoyaltyProgramCapability {
  id: string;
  logoUrl: URL | null;
  conditionsUrl: URL | null;
  enrollmentUrl: URL | null;
  detailsUrl: URL | null;
  processingDelay: number;
  category: LoyaltyProgramCapabilities;
}
